<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/ticket/ticketListReviewAudit")
          i.fas.fa-list-alt
          span.ml-1 {{ $t("ui.audit_list") }}
  b-card(body-class="").p-0
    div(slot="header")
      div.row.col-md-12.mb-1
        div(width="10%").mr-3
          SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="getTicketList" size="sm" variant="info")
        div(width="65%").mr-3
          b-input-group(size="sm").mb-1
            b-input-group-text(slot="prepend")
              div.d-flex.justify-content-center.align-items-center
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(type="checkbox" v-model="$options.refreshOn" @change="toggleRefresh()")
                  span.switch-slider(:data-checked='on' :data-unchecked='off')
            b-input(v-model="refreshInterval" type="range" min="1" max="5")
            b-input-group-text(slot="append")
              div(style="text-transform: none;") {{ refreshInterval }} s
        div(width="10%")
          SubmitButton(
            ref="search_btn"
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getTicketList()"
            variant="success"
            size="sm"
            )
      div.row
        div.col-md-2.mb-1
          b-input-group(size="sm").mb-1
            b-input-group-text(slot="prepend")
              span {{ $t('ui.search_by_id') }}
            b-input-group-text(slot="append")
              div.d-flex.justify-content-center.align-items-center
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(type="checkbox" v-model="searchById" @input="resetInput()")
                  span.switch-slider(:data-checked='on' :data-unchecked='off')
        div.row.col-md-10.mb-1
          div(width="20%" v-if="searchById == true").mr-3
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.ticket_id') }}
              DebounceInput(type="text" v-model="ticketId")
          div(width="20%" v-if="searchById == false").mr-3
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.member') }}
              DebounceInput(type="text" v-model="search" @enter="getTicketList()")
          //- div(width="20%" v-if="searchById == false").mr-3
          //-   b-input-group(size="sm")
          //-     b-input-group-text(slot="prepend")
          //-       span {{ $t('ui.status') }}
          //-     b-form-select(v-model="ticketStatus" @change="getTicketList")
          //-       option(value="") {{ $t('ui.all') }}
          //-       option(value="REVIEW") {{ $tc('ui.review', 1) }}
          //-       option(value="AUDIT") {{ $t('ui.audit') }}
    b-tabs(small card)
      b-tab(title-link-class="small-link" title-item-class="small-item")
        template(slot="title")
          span(style="padding: 1px; line-height: 16px;") {{ $t("ui.withdrawal") }}
          b-badge(variant="danger" size="sm" style="width: 30px; vertical-align: top;").ml-1 {{ totalRow }}
        div.d-flex.flex-wrap
          div.clusterize
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
            .clusterize-scroll
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th.sticky-position(width="3%")
                      span #
                    th.sticky-position(width="5%")
                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                    th.sticky-position.sortable(width="8%" @click="sortOrder('member_id')")
                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                      i(:class="changeSortKey('member_id')")
                    th.sticky-position.sortable(width="7%" @click="sortOrder('amount')")
                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      i(:class="changeSortKey('amount')")
                    th.sticky-position.sortable(width="5%" @click="sortOrder('target_bank_id')")
                      span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                      i(:class="changeSortKey('target_bank_id')")
                    th.sticky-position.sortable(width="8%" @click="sortOrder('target_bank_acc_no')")
                      span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      i(:class="changeSortKey('target_bank_acc_no')")
                    th.sticky-position.sortable(width="6%" @click="sortOrder('status')")
                      span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      i(:class="changeSortKey('status')")
                    th.sticky-position.sortable(width="6%")
                      span(:title="$t('ui.rollback_count')") {{ $t("ui.rollback_count") }}
                    th.sticky-position(width="6%")
                      span(:title="$t('ui.rejected_ticket_id')") {{ $t("ui.rejected_ticket_id") }}
                    th.text-center.sticky-position(width="8%")
                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('created_date')")
                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                      i(:class="changeSortKey('created_date')")
                tbody.clusterize-content
                  tr(v-if="withdrawalList.length == 0")
                    td(:colspan="11").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in withdrawalList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                    td
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="item.id") {{ item.id }}
                    td
                      span.font-weight-bold(:title="item.member_id")
                        b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                    td
                      span.font-weight-bold.text-secondary(v-if="item.status.trim().toUpperCase() == 'REVIEW'") {{ item.status.trim().toUpperCase() }}
                      span.font-weight-bold.text-primary(v-if="item.status.trim().toUpperCase() == 'AUDIT'") {{ item.status.trim().toUpperCase() }}
                    td
                      span.font-weight-bold(:title="$n(item.rollback_count, 'integer')" v-if="item.rollback_count")
                        b-link.clickable(href="javascript:void(0);" @click="onGetRollbackDetail(item)") {{ $n(item.rollback_count, 'integer') }}
                      span(v-else) {{ item.rollback_count }}
                    td
                      span.font-weight-bold(:title="item.rejected_ticket_id" v-if="item.rejected_ticket_id")
                        b-link.clickable(href="javascript:void(0);" @click="onGetRejectDetail(item)") {{ item.rejected_ticket_id }}
                      span(v-else) {{ item.rejected_ticket_id }}
                    td.actions
                      span
                        a.fa.fa-search.text-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                      span(v-if="item.status.trim().toUpperCase() == 'REVIEW'")
                        a.fa.fa-check-double.text-warning(href="javascript:void(0)" @click="auditTicket(item, $event)" :title="$t('ui.audit')")
                      span
                        a.fa.fa-check.text-secondary(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                      span
                        a.fas.fa-check-circle.text-success(href="javascript:void(0)" @click="manualApproveTicket(item, $event)" :title="$t('ui.manual_approve')")
                      span
                        a.fa.fa-ban.text-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                    td.text-right
                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    approveticket(ref="approveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    auditticket(ref="auditticket" :ticketId="selectedTicketId" :memberId="selectedMemberId" @clicked="afterAuditTicket" @failed="handleFailed")
    rejectticket(ref="rejectticket" :ticketId="selectedTicketId" @clicked="afterEditTicket" @failed="handleFailed")
    getrecentdeposit(ref="getrecentdeposit" :item="editSelectedMember" @failed="handleFailed")
    getrollbackdetail(ref="getrollbackdetail" :item="selectedTicket" @failed="handleFailed")
    getrejectdetail(ref="getrejectdetail" :item="selectedTicket" @failed="handleFailed")
    manualapproveticket(ref="manualapproveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    memberdetails(ref="memberdetails" :memberId="selectedMemberId" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import approveticket from "@/components/ticket/approveTicket.vue";
import rejectticket from "@/components/ticket/rejectTicket.vue";
import auditticket from "@/components/ticket/auditTicket.vue";
import getrecentdeposit from "@/components/ticket/getRecentDeposit.vue";
import getrollbackdetail from "@/components/ticket/getRollbackDetail.vue";
import getrejectdetail from "@/components/ticket/getRejectDetail.vue";
import manualapproveticket from "@/components/ticket/manualApproveTicket.vue";
import memberdetails from "@/components/member/memberDetails.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    approveticket,
    auditticket,
    rejectticket,
    getrecentdeposit,
    getrollbackdetail,
    getrejectdetail,
    manualapproveticket,
    memberdetails
  },
  data: () => ({
    loading: false,
    withdrawalList: [],
    currentDepPage: 1,
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    requestType: null,
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    selectedTicketId: null,
    selectedTicket: null,
    selectedParentId: null,
    selectedMemberId: null,
    sortKey: "created_date",
    sortType: "desc",
    al: null,
    search: '',
    editSelectedMember: null,
    searchById: false,
    ticketId: "",
    ticketStatus: "",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    this.getTicketList();
  },
  destroyed: function() {
    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    } 
    var json = {
      tab: null
    };
    this.$store.dispatch("user/setPendingTicketParam", json);
  },
  methods: {
    resetInput() {
      this.search = "";
      this.ticketId = "";
    },
    getRefNo: function(id, pg, mode) {
      if (pg == null)
        return "";

      if (pg.trim().toUpperCase() == "AIPAY")
        return config.pgIDPrefix + "APP@" + id;
      else if (pg.trim().toUpperCase() == "HTPAY" && (['GCASH','GCASHQR'].includes(mode.trim().toUpperCase())))
        return config.pgIDPrefix + "PHP@" + id;
      else if (pg.trim().toUpperCase() == "HTPAY" && (['MAYA'].includes(mode.trim().toUpperCase())))
        return config.pgIDPrefix + "MMP@" + id;
      else if (pg.trim().toUpperCase() == "MAYAPAY")
        return config.pgIDPrefix + "MMP@" + id;
      else if (pg.trim().toUpperCase() == "RMPAY")
        return config.pgIDPrefix + "RRP@" + id;
      else if (pg.trim().toUpperCase() == "GOPAYGCASH")
        return config.pgIDPrefix + "GPG@" + id;
      else if (pg.trim().toUpperCase() == "GOPAYMAYA")
        return config.pgIDPrefix + "GPM@" + id;
      else if (pg.trim().toUpperCase() == "DGPAYGCASH")
        return config.pgIDPrefix + "DGG@" + id;
      else if (pg.trim().toUpperCase() == "DGPAYMAYA")
        return config.pgIDPrefix + "DGM@" + id;
      else if (pg.trim().toUpperCase() == "CLOUDPAY")
        return config.pgIDPrefix + "CPPA" + id;
      else if (pg.trim().toUpperCase() == "TOPPAY")
        return config.pgIDPrefix + "TPP@" + id;
      else if (pg.trim().toUpperCase() == "ANFU")
        return config.pgIDPrefix + "ANF@" + id;
      else if (pg.trim().toUpperCase() == "SHUNFAPAYGCASH")
        return config.pgIDPrefix + "SFG@" + id;
      else if (pg.trim().toUpperCase() == "SHUNFAPAYMAYA")
        return config.pgIDPrefix + "SFM@" + id;
      else if (pg.trim().toUpperCase() == "WORLDPAY")
        return config.pgIDPrefix + "EPICPHPYMNTGTWYDEPA" + id;
      else if (pg.trim().toUpperCase() == "RGPAY")
        return config.pgIDPrefix + "RGGA" + id;
      else if (pg.trim().toUpperCase() == "WCPAY")
        return config.pgIDPrefix + "WCCA" + id;
      else if (pg.trim().toUpperCase() == "GOLDPAY")
        return config.pgIDPrefix + "GPPA" + id;
      else if (pg.trim().toUpperCase() == "XFTGCASH")
        return config.pgIDPrefix + "XFF@" + id;
      else if (pg.trim().toUpperCase() == "MASAYAPAY")
        return config.pgIDPrefix + "MSY@" + id;
      else if (pg.trim().toUpperCase().startsWith('TYGPAY'))
        return config.pgIDPrefix + "TYG@" + id;
      else if (pg.trim().toUpperCase() == "XYPAY")
        return config.pgIDPrefix + "XYY@" + id;
      else if (pg.trim().toUpperCase() == "XFTUSDT")
        return config.pgIDPrefix + "XFU@" + id;
      else if (pg.trim().toUpperCase() == "CTPAY")
        return config.pgIDPrefix + "CTT@" + id;

      return "";
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getWithdrawalList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getTicketList() {
      this.getWithdrawalList(true);
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListReviewAuditUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        request_type: 'WITHDRAWAL',
        ticket_id: this.ticketId == "" ? null : this.$helpers.getTicketId(this.ticketId),
        // ticket_status: this.ticketStatus == "" ? null : this.ticketStatus,
        ticket_status: "AUDIT",
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.member_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.totalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    onGetRollbackDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrollbackdetail.$refs.getRollbackDetail.show();
    },
    onGetRejectDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrejectdetail.$refs.getRejectDetail.show();
    },
    afterEditTicket: function(type, afterBalance) {
      this.getTicketList();

      if (type == 1) {
        this.$swal({
          title: this.$t("ui.combine.edit_ticket"),
          html:
            "<div>" +
            this.$t("ui.after_balance") +
            ": <strong>" +
            this.$n(afterBalance, 'currency') +
            "</strong></div>",
          type: "success",
          confirmButtonText: this.$t("ui.ok"),
          allowOutsideClick: false
        }).then(isConfirm => {
          if (isConfirm.value) {

          }
        });
      } else
        this.$helpers.showDialog(this.$t("ui.combine.edit_ticket"), this.$t("message.success"), "success");
    },
    afterAuditTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.audit_ticket"), this.$t("message.success"), "success");
    },
    auditTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedMemberId = e.member_id;
      this.$refs.auditticket.$refs.auditTicket.show();
    },
    approveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.approveticket.$refs.approveTicket.show();
    },
    manualApproveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.manualapproveticket.$refs.manualApproveTicket.show();
    },
    rejectTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectticket.$refs.rejectTicket.show();
    },
    onInfo(e) {
      this.selectedMemberId = e.member_id;
      this.$refs.memberdetails.$refs.memberDetails.show();
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getWithdrawalList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>